export default __webpack_public_path__ + "static/media/README.7cdd00f7.md";